import { render, staticRenderFns } from "./news-card.html?vue&type=template&id=037a6d89&scoped=true&"
import script from "./news-card.js?vue&type=script&lang=js&"
export * from "./news-card.js?vue&type=script&lang=js&"
import style0 from "./news-card.scss?vue&type=style&index=0&id=037a6d89&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037a6d89",
  null
  
)

export default component.exports